<template>
    <div class="product-page-template-module">
        <product-page
            :breadcrumbs="breadcrumbs"
            :product="productData"
            :categories="attributes.asyncData.categories"
            type="product"
        />

        <page-module-builder
            :components="templateComponents"
        />
    </div>
</template>

<script>
    import PageModuleBuilder from '../../PageModuleBuilder/PageModuleBuilder';
    import ProductPage from '../../../organisms/ProductPage/ProductPage';
    import { formatBreadcrumbsForProductPage, formatDataForProductPage } from '../../../../lib/product';

    export default {
        name: 'product-page-template-module',

        components: { ProductPage, PageModuleBuilder },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ store }) {
            const categories = await store.dispatch('products/fetchCategories');

            return {
                categories,
            };
        },

        computed: {
            /**
             * Convert the attributes to components.
             *
             * @returns {Array}
             */
            templateComponents() {
                return Object.entries(this.attributes)
                    .filter(([, val]) => typeof val === 'object' && val?.__typename)
                    .reduce((components, [, val]) => ([
                        ...components,
                        {
                            __page: this.attributes.__page,
                            ...val,
                        },
                    ]), []);
            },

            /**
             * Return the product data to pass to the product page.
             *
             * @returns {object}
             */
            productData() {
                return formatDataForProductPage(this, this.attributes);
            },

            /**
             * Generate breadcrumbs.
             *
             * @returns {Array}
             */
            breadcrumbs() {
                return formatBreadcrumbsForProductPage(this, this.attributes);
            },
        },
    };
</script>
